import { create } from 'zustand'
import type { User, SubscriptionInfo } from '@/types'

interface AuthState {
  user: User | null
  currentAssistantId: string | null
  subscriptionInfo: SubscriptionInfo | null
  isAuthenticated: boolean

  setUser: (user: User | null) => void
  setCurrentAssistant: (id: string | null) => void
  setSubscriptionInfo: (info: SubscriptionInfo | null) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  currentAssistantId: localStorage.getItem('currentAssistantId'),
  subscriptionInfo: null,
  isAuthenticated: !!localStorage.getItem('access_token'),

  setUser: (user) => set({ user, isAuthenticated: !!user }),

  setCurrentAssistant: (id) => {
    if (id) localStorage.setItem('currentAssistantId', id)
    else localStorage.removeItem('currentAssistantId')
    set({ currentAssistantId: id })
  },

  setSubscriptionInfo: (info) => set({ subscriptionInfo: info }),

  logout: () => {
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('currentAssistantId')
    set({ user: null, currentAssistantId: null, subscriptionInfo: null, isAuthenticated: false })
  },
}))
